import { render } from "./HomeView.vue?vue&type=template&id=fe12dcb6&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=fe12dcb6&lang=stylus"
import "./HomeView.vue?vue&type=style&index=1&id=fe12dcb6&scoped=true&lang=stylus"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe12dcb6"]])

export default __exports__